import { combineReducers } from "redux";
import vehiclesReducer from "./vehicleReducer";
import labeledVehiclesReducer from "./labeledVehiclesReducer";
import vehicleListReducer from "./vehicleListReducer";
import settingsReducer from "./settingsReducer";
import faultCodesReducer from "./faultCodesReducer";
import alertPreferencesReducer from "./alertPreferencesReducer";
import routeReducer from "./routeReducer";
import vehicleSelectionReducer from "./vehicleSelectionReducer";
import popupReducer from "./popupReducer";
import lastOnlineReducer from "./lastOnlineReducer";
import customerGroupPerEmailReducer from "./customerGroupPerEmailReducer";

const rootReducer = combineReducers({
  vehicle: vehiclesReducer,
  labeledVehicles: labeledVehiclesReducer,
  vehicleList: vehicleListReducer,
  settings: settingsReducer,
  faultCodes: faultCodesReducer,
  alertPreferences: alertPreferencesReducer,
  vehicleRoutes: routeReducer,
  vehicleSelection: vehicleSelectionReducer,
  popupView: popupReducer,
  lastOnline: lastOnlineReducer,
  customerGroupPerEmail: customerGroupPerEmailReducer,
});

export default rootReducer;

//export type State = ReturnType<typeof rootReducer>;
